<template>
  <div>
    <div class="tenant-header">
      <AssetV3
        dir="logos"
        name="logo.svg"
      />

      <p
        class="hide-on-large primary body-regular"
        @click="handleDetailModal"
      >
        Detalhes
      </p>
    </div>

    <div class="details-modal hide-on-large" :class="{ open: detailModalOpen }">
      <ProposalDetails @back="handleDetailModal" />
    </div>

    <slot />
  </div>
</template>

<script>
import AssetV3 from '@/components/common/AssetV3.vue';
import ProposalDetails from './ProposalDetails.vue';

export default {
  name: 'tenantHeader',
  components: {
    AssetV3,
    ProposalDetails,
  },
  data: () => ({
    detailModalOpen: false,
  }),
  methods: {
    handleDetailModal() {
      this.detailModalOpen = !this.detailModalOpen;
      document.documentElement.style.overflow = this.detailModalOpen ? 'hidden' : 'auto';
    },
  },
};
</script>

<style lang="scss" scoped>
  @media (max-width: $breakpoint-large) {
    .tenant-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .details-modal {
      position: fixed;
      top: 0;
      left: 100%;
      width: 100%;
      height: 100%;
      background-color: var(--white);
      z-index: 1;
      transition: 0.4s;

      &.open {
        left: 0;
      }
    }
  }
</style>
